import { createSlice } from "@reduxjs/toolkit";

const projectsSlice = createSlice({
  name: "projects",
  initialState: {
    items: [],
    loading: false,
    error: null,
    currentProjectDetail: null,
    currentProjectInformation: null,
    detailLoading: false,
    detailError: null,
    informationLoading: false,
    informationError: null,
    shares: [],
    sharesLoading: false,
    sharesError: null,
    shareLink: null,
    shareLinkLoading: false,
    shareLinkError: null,
    userPermission: null,
    permissionLoading: false,
    permissionError: null,
    frameworks: [],
    frameworksLoading: false,
    frameworksError: null,
    rieLoading: false,
    rieError: null,
    stakeholdersLoading: false,
    stakeholdersError: null,
  },
  reducers: {
    fetchProjectsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchProjectsSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload;
    },
    fetchProjectsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createProjectRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createProjectSuccess: (state, action) => {
      state.loading = false;
      state.items = [action.payload, ...state.items];
    },
    createProjectFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchProjectDetailRequest: (state) => {
      state.detailLoading = true;
      state.detailError = null;
    },
    fetchProjectDetailSuccess: (state, action) => {
      state.detailLoading = false;
      state.currentProjectDetail = action.payload;
    },
    fetchProjectDetailFailure: (state, action) => {
      state.detailLoading = false;
      state.detailError = action.payload;
    },
    updateProjectRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    updateProjectSuccess: (state, action) => {
      state.loading = false;

      const updatedProject = action.payload;

      // update in projects list
      state.items = state.items.map((project) =>
        project.id === updatedProject.id ? updatedProject : project
      );

      // update detail page if open
      if (
        state.currentProjectDetail &&
        state.currentProjectDetail.id === updatedProject.id
      ) {
        state.currentProjectDetail = updatedProject;
      }
    },

    updateProjectFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchProjectInformationRequest: (state) => {
      state.informationLoading = true;
      state.informationError = null;
    },
    fetchProjectInformationSuccess: (state, action) => {
      state.informationLoading = false;
      state.currentProjectInformation = action.payload;
    },
    fetchProjectInformationFailure: (state, action) => {
      state.informationLoading = false;
      state.informationError = action.payload;
    },
    updateProjectInformationRequest: (state) => {
      state.informationLoading = true;
      state.informationError = null;
    },
    updateProjectInformationSuccess: (state, action) => {
      state.informationLoading = false;
      state.currentProjectInformation = action.payload;
    },
    updateProjectInformationFailure: (state, action) => {
      state.informationLoading = false;
      state.informationError = action.payload;
    },
    shareProjectRequest: (state) => {
      state.sharesLoading = true;
      state.sharesError = null;
    },
    shareProjectSuccess: (state) => {
      state.sharesLoading = false;
    },
    shareProjectFailure: (state, action) => {
      state.sharesLoading = false;
      state.sharesError = action.payload;
    },
    generateShareLinkRequest: (state) => {
      state.shareLinkLoading = true;
      state.shareLinkError = null;
    },
    generateShareLinkSuccess: (state, action) => {
      state.shareLinkLoading = false;
      state.shareLink = action.payload;
    },
    generateShareLinkFailure: (state, action) => {
      state.shareLinkLoading = false;
      state.shareLinkError = action.payload;
    },
    fetchProjectSharesRequest: (state) => {
      state.sharesLoading = true;
      state.sharesError = null;
    },
    fetchProjectSharesSuccess: (state, action) => {
      state.sharesLoading = false;
      state.shares = action.payload;
    },
    fetchProjectSharesFailure: (state, action) => {
      state.sharesLoading = false;
      state.sharesError = action.payload;
    },
    updateSharePermissionRequest: (state) => {
      state.sharesLoading = true;
      state.sharesError = null;
    },
    updateSharePermissionSuccess: (state, action) => {
      state.sharesLoading = false;
      const updatedShare = action.payload;
      state.shares = state.shares.map((share) =>
        share.id === updatedShare.id ? updatedShare : share
      );
    },
    updateSharePermissionFailure: (state, action) => {
      state.sharesLoading = false;
      state.sharesError = action.payload;
    },
    revokeShareRequest: (state) => {
      state.sharesLoading = true;
      state.sharesError = null;
    },
    revokeShareSuccess: (state, action) => {
      state.sharesLoading = false;
      state.shares = state.shares.filter((share) => share.id !== action.payload);
    },
    revokeShareFailure: (state, action) => {
      state.sharesLoading = false;
      state.sharesError = action.payload;
    },
    acceptShareRequest: (state) => {
      state.sharesLoading = true;
      state.sharesError = null;
    },
    acceptShareSuccess: (state) => {
      state.sharesLoading = false;
    },
    acceptShareFailure: (state, action) => {
      state.sharesLoading = false;
      state.sharesError = action.payload;
    },
    fetchUserPermissionRequest: (state) => {
      state.permissionLoading = true;
      state.permissionError = null;
    },
    fetchUserPermissionSuccess: (state, action) => {
      state.permissionLoading = false;
      state.userPermission = action.payload;
    },
    fetchUserPermissionFailure: (state, action) => {
      state.permissionLoading = false;
      state.permissionError = action.payload;
    },
    fetchFrameworksRequest: (state) => {
      state.frameworksLoading = true;
      state.frameworksError = null;
    },

    //frameowrk
    fetchFrameworksSuccess: (state, action) => {
      state.frameworksLoading = false;
      state.frameworks = action.payload;
    },

    fetchFrameworksFailure: (state, action) => {
      state.frameworksLoading = false;
      state.frameworksError = action.payload;
    },

    // project rdd
    fetchProjectRddsRequest: (state) => {
      state.rddsLoading = true;
    },
    fetchProjectRddsSuccess: (state, action) => {
      state.rddsLoading = false;
      if (state.currentProjectDetail) {
        state.currentProjectDetail.rdds = action.payload;
      }
    },
    fetchProjectRddsFailure: (state, action) => {
      state.rddsLoading = false;
      state.error = action.payload;
    },

    saveProjectRddsRequest: (state) => {
      state.rddsLoading = true;
    },
    saveProjectRddsSuccess: (state, action) => {
      state.rddsLoading = false;
      if (state.currentProjectDetail) {
        state.currentProjectDetail.rdds = action.payload;
      }
    },
    saveProjectRddsFailure: (state, action) => {
      state.rddsLoading = false;
      state.error = action.payload;
    },

    // RIE
    fetchProjectRieRequest: (state) => {
      state.rieLoading = true;
    },
    fetchProjectRieSuccess: (state, action) => {
      state.rieLoading = false;
      if (state.currentProjectDetail) {
        state.currentProjectDetail.rie = action.payload;
      }
    },
    fetchProjectRieFailure: (state, action) => {
      state.rieLoading = false;
      state.error = action.payload;
    },

    saveProjectRieRequest: (state) => {
      state.rieLoading = true;
    },
    saveProjectRieSuccess: (state, action) => {
      state.rieLoading = false;
      if (state.currentProjectDetail) {
        state.currentProjectDetail.rie = action.payload;
      }
    },
    saveProjectRieFailure: (state, action) => {
      state.rieLoading = false;
      state.error = action.payload;
    },
    // Stakeholders
    fetchProjectStakeholdersRequest: (state) => {
      state.stakeholdersLoading = true;
    },

    fetchProjectStakeholdersSuccess: (state, action) => {
      state.stakeholdersLoading = false;
      if (state.currentProjectDetail) {
        state.currentProjectDetail.stakeholders = action.payload;
      }
    },

    fetchProjectStakeholdersFailure: (state, action) => {
      state.stakeholdersLoading = false;
      state.error = action.payload;
    },

    saveProjectStakeholdersRequest: (state) => {
      state.stakeholdersLoading = true;
    },

    saveProjectStakeholdersSuccess: (state, action) => {
      state.stakeholdersLoading = false;
      if (state.currentProjectDetail) {
        state.currentProjectDetail.stakeholders = action.payload;
      }
    },

    saveProjectStakeholdersFailure: (state, action) => {
      state.stakeholdersLoading = false;
      state.error = action.payload;
    },

    // DELETE stakeholder
    deleteProjectStakeholderRequest: (state) => {
      state.stakeholdersLoading = true;
    },

    deleteProjectStakeholderSuccess: (state, action) => {
      state.stakeholdersLoading = false;

      const deletedId = action.payload;

      // 🔥 remove from currentProjectDetail instantly
      if (state.currentProjectDetail?.stakeholders) {
        state.currentProjectDetail.stakeholders =
          state.currentProjectDetail.stakeholders.filter(
            (s) => s.id !== deletedId
          );
      }
    },

    deleteProjectStakeholderFailure: (state, action) => {
      state.stakeholdersLoading = false;
      state.error = action.payload;
    },

    // Update stakeholder position (drag)
    updateStakeholderPositionRequest: (state, action) => {
      const { stakeholderId, interest, influence } = action.payload;

      const stakeholder = state.currentProjectDetail?.stakeholders?.find(
        (s) => s.id === stakeholderId
      );

      if (stakeholder) {
        stakeholder.interest = interest;
        stakeholder.influence = influence;
      }
    },

    updateStakeholderPositionSuccess: (state, action) => {
      const updated = action.payload;

      if (!state.currentProjectDetail?.stakeholders) return;

      const stakeholder = state.currentProjectDetail.stakeholders.find(
        (s) => s.id === updated.id
      );

      if (stakeholder) {
        stakeholder.interest = updated.interest;
        stakeholder.influence = updated.influence;
      }
    },

    updateStakeholderPositionFailure: (state, action) => {
      console.error("Position update failed:", action.payload);
    },

    deleteProjectRieSiteRequest: (state) => {
      state.loading = true;
    },
    deleteProjectRieSiteSuccess: (state, action) => {
      state.loading = false;

      const deletedId = action.payload;

      if (state.currentProjectDetail?.rie?.sites) {
        state.currentProjectDetail.rie.sites =
          state.currentProjectDetail.rie.sites.filter(
            (site) => site.id !== deletedId
          );
      }
    },
    deleteProjectRieSiteFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    deleteProjectRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    deleteProjectSuccess: (state, action) => {
      state.loading = false;

      const deletedId = action.payload;

      // ✅ Remove from list
      state.items = state.items.filter(
        (project) => project.id !== deletedId
      );

      // ✅ If currently open project → clear it
      if (
        state.currentProjectDetail &&
        state.currentProjectDetail.id === deletedId
      ) {
        state.currentProjectDetail = null;
      }
    },

    deleteProjectFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

  },
});

export const {
  fetchProjectsRequest,
  fetchProjectsSuccess,
  fetchProjectsFailure,
  createProjectRequest,
  createProjectSuccess,
  createProjectFailure,
  fetchProjectDetailRequest,
  fetchProjectDetailSuccess,
  fetchProjectDetailFailure,
  updateProjectRequest,
  updateProjectSuccess,
  updateProjectFailure,
  fetchProjectInformationRequest,
  fetchProjectInformationSuccess,
  fetchProjectInformationFailure,
  updateProjectInformationRequest,
  updateProjectInformationSuccess,
  updateProjectInformationFailure,
  shareProjectRequest,
  shareProjectSuccess,
  shareProjectFailure,
  generateShareLinkRequest,
  generateShareLinkSuccess,
  generateShareLinkFailure,
  fetchProjectSharesRequest,
  fetchProjectSharesSuccess,
  fetchProjectSharesFailure,
  updateSharePermissionRequest,
  updateSharePermissionSuccess,
  updateSharePermissionFailure,
  revokeShareRequest,
  revokeShareSuccess,
  revokeShareFailure,
  acceptShareRequest,
  acceptShareSuccess,
  acceptShareFailure,
  fetchUserPermissionRequest,
  fetchUserPermissionSuccess,
  fetchUserPermissionFailure,
  fetchFrameworksRequest,
  fetchFrameworksSuccess,
  fetchFrameworksFailure,
  fetchProjectRddsRequest,
  fetchProjectRddsSuccess,
  fetchProjectRddsFailure,
  saveProjectRddsRequest,
  saveProjectRddsSuccess,
  saveProjectRddsFailure,
  fetchProjectRieRequest,
  fetchProjectRieSuccess,
  fetchProjectRieFailure,
  saveProjectRieRequest,
  saveProjectRieSuccess,
  saveProjectRieFailure,
  fetchProjectStakeholdersRequest,
  fetchProjectStakeholdersSuccess,
  fetchProjectStakeholdersFailure,
  saveProjectStakeholdersRequest,
  saveProjectStakeholdersSuccess,
  saveProjectStakeholdersFailure,
  updateStakeholderPositionRequest,
  updateStakeholderPositionSuccess,
  updateStakeholderPositionFailure,
  deleteProjectStakeholderRequest,
  deleteProjectStakeholderSuccess,
  deleteProjectStakeholderFailure,
  deleteProjectRieSiteRequest,
  deleteProjectRieSiteSuccess,
  deleteProjectRieSiteFailure,
  deleteProjectRequest,
  deleteProjectSuccess,
  deleteProjectFailure,
} = projectsSlice.actions;

export default projectsSlice.reducer;

